// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearcherList-cls1_CtE","cls2":"ResearcherList-cls2_snx ResearcherList-cls1_CtE"};